// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"3":"071cd0bb","185":"2476e2f1"}[chunkId] + ".css";
};